import { combineReducers } from "@reduxjs/toolkit"
import modalReducer from "./modalReducer";
import userReducer from "./userReducer";
import notificationReducer from "./notificationReducer";
import snackBarReducer from "./snackbarReducer";
import fittingReducer from "./fittingReducer";
import fittingReducerLeft from "./fittingReducerLeft";
import ricLeftFittingReducer from "./ricLeftFittingReducer";
import ricRightFittingReducer from "./ricRightFittingReducer";

const rootReducer = combineReducers({
    user: userReducer,
    modal: modalReducer,    
    notifications: notificationReducer,
    fitting:fittingReducer,
    fittingLeft:fittingReducerLeft,
    ricLeftFitting: ricLeftFittingReducer,
    ricRightFitting:ricRightFittingReducer,
    snackBar: snackBarReducer
})
export default rootReducer;